module.exports = __webpack_public_path__ + "img/hombre_contento.68d60b8f.png";